import { TextField } from '@mui/material';
import { useLanguage } from '../../../../contexts/language';
import { OperatorPartialFormProps } from '../types';
import FormLayout, {
  FormLayoutInputElement,
} from '../../../../components/FormLayout';

const OperatorContactForm = ({ formManager }: OperatorPartialFormProps) => {
  const { t } = useLanguage();
  const {
    formState: { updateValues },
    materialInputHelpers: { getTextFieldProps },
  } = formManager;
  return (
    <FormLayout>
      <FormLayoutInputElement
        required
        helperText={t('content.company-email-address-description')}
        label={t('content.company-email-address')}
      >
        <TextField
          {...getTextFieldProps('companyEmailAddress')}
          placeholder={t('content.company-email-address')}
        />
      </FormLayoutInputElement>
      <FormLayoutInputElement
        required
        label={t('content.company-phone-number')}
      >
        <TextField
          {...getTextFieldProps('companyPhoneNumber')}
          onChange={event => {
            const inputValue = event.target.value;
            const onlyNumbers = inputValue.replace(/\D/g, ''); // Remove non-digit characters

            updateValues({ companyPhoneNumber: onlyNumbers });
          }}
          placeholder={t('content.company-phone-number')}
        />
      </FormLayoutInputElement>
    </FormLayout>
  );
};

export default OperatorContactForm;
